import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

// export const useCounterStore = defineStore('counter', () => {
//   const count = ref(0)
//   const doubleCount = computed(() => count.value * 2)
//   function increment() {
//     count.value++
//   }

//   return { count, doubleCount, increment }
// })

export const useInfoStore = defineStore('userInfo', {
  state: () => ({
    userInfo: '',
    showLoginModal: false
  }),
  actions: {
    async setUserInfo(data) {
      this.userInfo = data
    },
    setShowLoginModal(value) {
      this.showLoginModal = value
    }
  }
})

export const initConfigStore = defineStore('initConfig', {
  state: () => ({
    initConfig: ''
  }),
  actions: {
    async setInitConfig(data) {
      this.initConfig = data
    }
  }
})
